import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { api } from '../api';
import { certDate, todayYmd } from '../common';

/** 발급 후 수료일 변경 (일련번호는 그대로, 이력 기록) */
export const CertDateDialog: React.FC<{ cert: { _id: string; serial: string; completedAt: string } | null; onClose: () => void; onDone: () => void }> = ({ cert, onClose, onDone }) => {
  const [date, setDate] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true); setError('');
    try {
      await api(`/admin/cert/certificates/${cert!._id}/date`, { body: { date, reason } });
      onDone(); onClose(); setDate(''); setReason('');
    } catch (e: any) { setError(e.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={Boolean(cert)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle fontWeight={800}>수료일 변경 · {cert?.serial}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Typography fontSize={13} color="text.secondary" mb={2}>현재: {cert && certDate(cert.completedAt)} · 일련번호는 바뀌지 않습니다. 교회 화면에 “날짜 변경됨 – 다시 받아주세요”가 표시됩니다.</Typography>
        <TextField type="date" label="새 수료일" fullWidth InputLabelProps={{ shrink: true }} value={date} inputProps={{ max: todayYmd() }} onChange={(e) => setDate(e.target.value)} sx={{ mb: 2 }} />
        <TextField label="변경 사유 (필수)" fullWidth multiline minRows={2} value={reason} onChange={(e) => setReason(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
        <Button variant="contained" disabled={!date || !reason.trim() || busy} onClick={submit}>변경</Button>
      </DialogActions>
    </Dialog>
  );
};

/** 수료증 취소 (번호는 재사용하지 않음, 보관함 파일 삭제, 보고서는 '확인 중'으로) */
export const CertRevokeDialog: React.FC<{ cert: { _id: string; serial: string; teacherName: string } | null; onClose: () => void; onDone: () => void }> = ({ cert, onClose, onDone }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const submit = async () => {
    try {
      await api(`/admin/cert/certificates/${cert!._id}/revoke`, { body: { reason } });
      onDone(); onClose(); setReason('');
    } catch (e: any) { setError(e.message); }
  };
  return (
    <Dialog open={Boolean(cert)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle fontWeight={800}>수료증 취소 · {cert?.serial}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Alert severity="warning" sx={{ mb: 2 }}>{cert?.teacherName} 선생님의 수료증이 무효가 됩니다. 번호 {cert?.serial}은 다시 쓰지 않으며, 보관함 사진이 지워지고 보고서는 ‘확인 중’으로 돌아갑니다.</Alert>
        <TextField label="취소 사유 (필수)" fullWidth multiline minRows={2} value={reason} onChange={(e) => setReason(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
        <Button variant="contained" color="error" disabled={!reason.trim()} onClick={submit} sx={{ background: '#b91c1c !important', color: '#fff !important' }}>수료증 취소</Button>
      </DialogActions>
    </Dialog>
  );
};
